import { Component, Input, OnInit } from '@angular/core';

import { Storyboard } from 'app/models/storyboard';
import {GoogleTagManagerService} from '../../../services/google-tag-manager.service';

@Component({
  selector: 'app-storyboard-item',
  templateUrl: './storyboard-item.component.html',
  styleUrls: ['./storyboard-item.component.scss']
})
export class StoryboardItemComponent implements OnInit {
  @Input() storyboard: Storyboard;

  constructor(private gtmService: GoogleTagManagerService) {}

  ngOnInit() {}

  SendStoryboardEvent() {
    this.gtmService.pushEvent('Storyboard - Open panel');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/storyboard-item/storyboard-item.component.ts